import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Connection,
  PublicKey,
  SystemProgram,
  LAMPORTS_PER_SOL,
  Transaction,
} from "@solana/web3.js";
import {
  TOKEN_PROGRAM_ID,
  createTransferInstruction,
  getAssociatedTokenAddress,
} from "@solana/spl-token";
import {
  bonusEnum,
  chainTypeEnum,
  coinTypeEnum,
  currencyTypeEnum,
  getLivePriceURL,
  maxUsdtBuy,
  minUsdtBuy,
  solChainEnum,
  solImage,
} from "../../config/enum";
import { useAuth } from "../../../AuthContext";
import {
  useGetStageQuery,
  useGetTokenRaisedQuery,
} from "../../../redux/stageApi";
import { useSetCheckUserMutation } from "../../../redux/user";
import axios from "axios";
import { Buffer } from "buffer";
import { toast } from "react-toastify";
import {
  useGetClaimTokenQuery,
  useGetUserTokenQuery,
  useSetClaimTokenMutation,
  useSetTransactionMutation,
} from "../../../redux/transactionApi";
import BuyPopup from "./BuyPopup";
import {
  createAppKit,
  useAppKitAccount,
  useAppKitProvider,
  useDisconnect,
  useWalletInfo,
} from "@reown/appkit/react";
import { SolanaAdapter } from "@reown/appkit-adapter-solana/react";
import { mainnet, solana } from "@reown/appkit/networks";
// import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets'
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-wallets";
import { BrowserProvider, Contract, parseEther } from "ethers";
// import LiveDate from "./LiveDate";
import Loader from "./Loader";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { eth_scotty_abi, eth_scotty_address } from "../../config/eth";
require("@solana/wallet-adapter-react-ui/styles.css");
window.Buffer = Buffer;

const shortenAddress = (address) => {
  return address ? `${address.slice(0, 4)}...${address.slice(-4)}` : "";
};

const adminPublicKey = process.env.REACT_APP_adminPublicKey;

function BuySell({ referralCode }) {
  const { authenticated, login, setWallet_address, logout } = useAuth();
  const { address, isConnected } = useAppKitAccount();
  const { walletProvider } = useAppKitProvider("solana");
  const { walletProvider: evmProvider } = useAppKitProvider("eip155");
  const { disconnect } = useDisconnect();
  const [setClaimToken] = useSetClaimTokenMutation();
  const { data: claimtoken,refetch:claimTokenFetch } = useGetClaimTokenQuery(undefined, {
    skip: !authenticated,
  });
  const { data: userToken, refetch: tokenRefetch } = useGetUserTokenQuery(
    undefined,
    {
      skip: !authenticated,
    }
  );
  const { data: stage, refetch } = useGetStageQuery();
  const { data: tokenRaised, refetch: raisedRefetch } =
    useGetTokenRaisedQuery();
  const [setTransaction] = useSetTransactionMutation();
  const [setCheckUser] = useSetCheckUserMutation();
  const [currency, setCurrency] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [chain, setChain] = useState(solChainEnum);
  const [chainImage, setChainImage] = useState(solImage);
  const [inputAmount, setInputAmount] = useState(0);
  const [scottyToken, setScottyToken] = useState(0);
  const [disable, setDisable] = useState(false);
  const [processBar, setProcessBar] = useState("");
  const [checkBox, setCheckBox] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [bonus, setBonus] = useState("");
  const [extrabonus, setExtraBonus] = useState("");
  const [extraAmount, setExtraAmount] = useState("");
  const [maxExtrabonus, setMaxExtraBonus] = useState("");
  const [maxExtraAmount, setMaxExtraAmount] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [usdtAmount, setUsdtAmount] = useState("");
  const [extraUsdtAmount, setExtraUsdtAmount] = useState("");
  const [maxExtraUsdtAmount, setMaxExtraUsdtAmount] = useState("");
  const [showClaim, setShowClaim] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [livetimeLeft, setLiveTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const solanaWeb3JsAdapter = new SolanaAdapter({
    wallets: [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
  });

   useEffect(() => {
    if(authenticated){
      claimTokenFetch()
    }
   }, [authenticated])
   

  const projectId = "6c9760534aa3c822cb8a072339bbca59";

  // 2. Create a metadata object - optional
  const metadata = {
    name: "AppKit",
    description: "AppKit Solana Example",
    url: "https://example.com", // origin must match your domain & subdomain
    icons: ["https://avatars.githubusercontent.com/u/179229932"],
  };
  const model = createAppKit({
    adapters: [solanaWeb3JsAdapter, new EthersAdapter()],
    networks: [solana, mainnet],
    metadata: metadata,
    projectId,
    features: {
      analytics: true, // Optional - defaults to your Cloud configuration
    },
  });

  useEffect(() => {
    if (authenticated) {
      tokenRefetch();
    }
  }, [authenticated, tokenRefetch]);

  useEffect(() => {
    if (chain) {
      setCurrencyData(currencyTypeEnum[chain]);
    }
  }, [chain]);

  useEffect(() => {
    if (stage && tokenRaised && tokenRaised.length > 0 && stage.length > 0) {
      const calculatebar = parseFloat(
        (tokenRaised[0]?.sold_scotty_token / stage[0]?.token_for_sale) * 100
      ).toFixed(2);
      setProcessBar(calculatebar + "%");
    }
  }, [tokenRaised, stage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "currency") {
      setCurrency(value);
      setInputAmount(0);
    }
    if (name === "inputAmount") {
      setInputAmount(value);
    }
  };

  useEffect(() => {
    calculateToken(inputAmount);
  }, [inputAmount]);

  const calculateToken = async (value) => {
    if (value && value != ".") {
      if (currency) {
        const currencyType = currencyData.filter(
          (list) => list.value === currency
        );
        if (currencyType[0].type === coinTypeEnum) {
          const tokenOneDollarPrice = 1 / stage[0].scotty_token_price;
          const getData = await axios.get(
            `${getLivePriceURL}${currencyType[0].priceCoin}USDT`
          );
          const getScottyToken =
            tokenOneDollarPrice *
            parseFloat(value) *
            parseFloat(getData.data.price);
          setScottyToken(parseFloat(getScottyToken).toFixed(2));
        } else {
          const getScottyToken =
            parseFloat(value) / stage[0]?.scotty_token_price;
          setScottyToken(parseFloat(getScottyToken).toFixed(2));
        }
      } else {
        toast.dismiss();
        toast.error("Please select currency");
      }
    } else {
      setScottyToken(0);
    }
  };
  const { walletInfo } = useWalletInfo();
  const isValidSolanaAddress = (address) => {
    try {
      return new PublicKey(address).toBase58() === address;
    } catch (e) {
      return false;
    }
  };
  useEffect(() => {
    if (address && isConnected) {
      const data = {
        wallet_address: address,
        referralCode: referralCode,
      };
      setDisable(true);
      setCheckUser(data).then((result) => {
        if (result.data && result.data.status) {
          login();
          localStorage.setItem("token", result.data.token);
          setWallet_address(address);
          localStorage.setItem("wallet_address", address);
          setTimeout(() => {
            setDisable(false);
            setShowClaim(isValidSolanaAddress(address));
          }, 3000);
        }
      });
    } else {
      logout();
    }
  }, [address, isConnected]);

  const ClaimToken = async () => {
    const data = {};
    setDisable(true);
    setClaimToken(data).then((result) => {
      if (result.data.status) {
        toast.dismiss();
        toast.success(result.data.message);
        setTimeout(() => {
          setDisable(false);
        }, 2000);
      } else {
        toast.dismiss();
        toast.error(result.data.message);
        setDisable(false);
      }
    });
  };

  useEffect(() => {
    if (authenticated) {
    }
  }, [authenticated]);

  const icoEndDate =
    stage?.length > 0
      ? new Date(stage && stage[0]?.end_date).getTime()
      : new Date().toLocaleString("en-US", { timeZone: "Asia/Dubai" });
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      const dubaiDate = new Date().toLocaleString("en-US", {
        timeZone: "Asia/Dubai",
      });
      const now = new Date(dubaiDate).getTime();
      const distance = icoEndDate - now;

      if (distance < 0) {
        clearInterval(countdownInterval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [icoEndDate]);
  const EndDate=new Date("2025-05-27 12:00:00").getTime()
  useEffect(() => {
    const countdownInterval = setInterval(() => {
    
      const utcString = new Date().toLocaleString("en-US", {
        timeZone: "UTC",
      });
      const now = new Date(utcString).getTime();
      const distance = EndDate - now;

      if (distance < 0) {
        clearInterval(countdownInterval);
        setLiveTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setLiveTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, []);

  const handleChain = async (value) => {
    setChain(value);
    setCurrency("");
    setInputAmount(0);
    setScottyToken(0);
    const chainType = chainTypeEnum.filter((list) => list.value == value);
    setChainImage(chainType[0].image);

    setCurrency("0");
    setInputAmount(0);
    setScottyToken(0);

    if (!address) {
      toast.dismiss();
      toast.error("Please connect wallet");
      return;
    }
    // if(value==solChainEnum){
    //   if(walletInfo?.name==="MetaMask"){
    //     await disconnect()
    //     toast.dismiss()
    //     toast.error("Please connect another wallet.")
    //     setTimeout(() => {
    //       model.open()
    //     }, 2000);
    //   }
    // }
  };

  const getSignerOrProvider = async (needSigner = false) => {
    try {
      if (!isConnected) {
        throw Error("User disconnected");
      }
      const ethersProvider = new BrowserProvider(evmProvider);
      const signer = await ethersProvider.getSigner();
      if (needSigner) {
        const signer = await ethersProvider.getSigner();
        return signer;
      }
      return signer;
    } catch (error) {
      throw error;
    }
  };

  const approveToken = async (
    tokenAddress,
    provider,
    spender,
    decimals,
    chainabi,
    amount
  ) => {
    try {
      const contract = new Contract(tokenAddress, chainabi, provider);
      const allowance = await contract.allowance(address, spender);
      const requiredAllowance = Number(amount) * Number(10 ** decimals);
      if (Number(allowance) < requiredAllowance) {
        const approvalTx = await contract.approve(
          spender,
          "10000000000000000000000000000000000000000000000000000"
        );
        await approvalTx.wait();
        toast.dismiss();
        toast.success("Approved successfully. Please don't refresh the page.");
        setDisable(false);
        return false;
      } else {
        return true;
      }
    } catch (error) {
      toast.error("Approval failed. Please try again.");
      setDisable(false);
      return false;
    }
  };

  const handleBuy = async (e) => {
    e.preventDefault();
    if (!address) {
      toast.dismiss();
      toast.error("Please connect your wallet");
      return;
    }
    if (chain == solChainEnum) {
      if (walletInfo?.name === "MetaMask") {
        await disconnect();
        toast.dismiss();
        toast.error("Please connect another wallet.");
        setTimeout(() => {
          model.open();
        }, 2000);
        return;
      }
    }
    if (currency === "") {
      toast.dismiss();
      toast.error("Please select currency");
      return;
    }
    if (inputAmount === "" || inputAmount <= 0) {
      toast.dismiss();
      toast.error("Please enter valid amount");
      return;
    }
    refetch();
    if (stage[0]?.left_token_for_sale < scottyToken) {
      toast.dismiss();
      toast.error("Insufficient token");
      return;
    }
    const currencyType = currencyData.filter((list) => list.value === currency);
    setCurrencyName(currencyType[0].key);
    let send_usdt_amount = 0;
    let live_USDT_Price = 0;
    if (currencyType[0].type === coinTypeEnum) {
      const getData = await axios.get(
        `${getLivePriceURL}${currencyType[0].priceCoin}USDT`
      );
      const liveUSDTPrice = parseFloat(getData.data.price);
      live_USDT_Price = liveUSDTPrice;
      const usdtAmount = minUsdtBuy / liveUSDTPrice;
      const maxusdtAmount = maxUsdtBuy / liveUSDTPrice;
      if (parseFloat(inputAmount) < parseFloat(usdtAmount).toFixed(8)) {
        toast.dismiss();
        toast.error(
          `Please enter minimum ${parseFloat(usdtAmount).toFixed(2)} ${
            currencyType[0].key
          }`
        );
        return;
      }
      if (parseFloat(inputAmount) > parseFloat(maxusdtAmount).toFixed(8)) {
        toast.dismiss();
        toast.error(
          `Please enter maximum ${parseFloat(maxusdtAmount).toFixed(2)} ${
            currencyType[0].key
          }`
        );
        return;
      }
      send_usdt_amount = inputAmount * parseFloat(getData.data.price);
    } else {
      if (inputAmount < minUsdtBuy) {
        toast.dismiss();
        toast.error(`Please buy token minimum ${minUsdtBuy} USDT`);
        return;
      }
      if (inputAmount > maxUsdtBuy) {
        toast.dismiss();
        toast.error(`Please buy token maximum ${maxUsdtBuy} USDT`);
        return;
      }
      send_usdt_amount = inputAmount;
    }
    if (checkBox) {
      setShowModal(true);
      setUsdtAmount(send_usdt_amount);
      const filterAmount = bonusEnum.filter(
        (list) =>
          list.minValue < send_usdt_amount && list.maxValue >= send_usdt_amount
      );
      const filterIndex = bonusEnum.findIndex(
        (list) =>
          list.minValue < send_usdt_amount && list.maxValue >= send_usdt_amount
      );
      if (filterIndex < 2) {
        setExtraBonus(bonusEnum[filterIndex + 1].bonusPer);
        const extUsdtAmount =
          bonusEnum[filterIndex + 1].minValue - send_usdt_amount;
        if (currencyType[0].type === coinTypeEnum) {
          setExtraAmount(
            parseFloat(extUsdtAmount / live_USDT_Price).toFixed(2)
          );
          setExtraUsdtAmount(extUsdtAmount);
        } else {
          setExtraAmount(extUsdtAmount);
          setExtraUsdtAmount(extUsdtAmount);
        }
      } else {
        setExtraBonus("");
        setExtraAmount("");
      }
      if (filterIndex == 0) {
        setMaxExtraBonus(bonusEnum[filterIndex + 2].bonusPer);
        const extUsdtAmount =
          bonusEnum[filterIndex + 2].minValue - send_usdt_amount;
        if (currencyType[0].type === coinTypeEnum) {
          setMaxExtraAmount(
            parseFloat(extUsdtAmount / live_USDT_Price).toFixed(2)
          );
          setMaxExtraUsdtAmount(extUsdtAmount);
        } else {
          setMaxExtraAmount(extUsdtAmount);
          setMaxExtraUsdtAmount(extUsdtAmount);
        }
      } else {
        setMaxExtraBonus("");
        setMaxExtraAmount("");
      }
      setBonus(filterAmount[0].bonusPer);
      return;
    }
    try {
      setDisable(true);
      if (chain === solChainEnum) {
        if (currencyType[0].priceCoin === "SOL") {
          const signature = await transfersol(inputAmount);
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: send_usdt_amount,
              trans_id: signature,
              to_address: adminPublicKey,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 10000);
          }
        } else {
          const signature = await transferSPLToken(
            currencyType[0]?.decimal,
            currencyType[0]?.mintAddress,
            inputAmount
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: send_usdt_amount,
              trans_id: signature,
              to_address: adminPublicKey,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 15000);
          }
        }
      } else {
        if (currencyType[0].type == coinTypeEnum) {
          const provider = await getSignerOrProvider();
          const contract = new Contract(
            eth_scotty_address,
            eth_scotty_abi,
            provider
          );
          const valueInWei = parseEther(inputAmount.toString());
          const trans = await contract.buyTokenWithETH(
            process.env.REACT_APP_adminAddress,
            {
              value: valueInWei,
            }
          );
          toast.dismiss();
          toast.info("Please Wait while we are validating transactions");
          await trans.wait();
          const transactionHash = trans.hash;
          const sendData = {
            user_address: address,
            chain: "ETH",
            currency: currencyType[0].key,
            amount: inputAmount,
            scotty_token: scottyToken,
            send_usdt_amount: send_usdt_amount,
            trans_id: transactionHash,
            to_address: process.env.REACT_APP_adminAddress,
          };
          setTimeout(() => {
            setTransaction(sendData).then((result) => {
              if (result.data.status) {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
                setInputAmount(0);
                refetch();
                raisedRefetch();
                tokenRefetch();
                toast.dismiss();
                toast.success("Token buy successfully");
              } else {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
              }
            });
          }, 5000);
        } else {
          const provider = await getSignerOrProvider();
          const result = await approveToken(
            currencyType[0].tokenAddress,
            provider,
            eth_scotty_address,
            currencyType[0].decimal,
            currencyType[0].abi,
            inputAmount
          );
          if (result) {
            let trans;
            let contract = new Contract(
              eth_scotty_address,
              eth_scotty_abi,
              provider
            );
            trans = await contract.buyWithToken(
              (inputAmount * 10 ** currencyType[0].decimal).toString(),
              currency
            );

            toast.dismiss();
            toast.info("Please Wait while we are validating transactions", {
              autoClose: false,
            });
            await trans.wait();
            const transactionHash = trans.hash;
            const sendData = {
              user_address: address,
              chain: "ETH",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: send_usdt_amount,
              trans_id: transactionHash,
              to_address: process.env.REACT_APP_adminAddress,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  toast.dismiss();
                  toast.success("Token buy successfully");
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 5000);
          }
        }
      }
    } catch (error) {
      if (error.code == "BAD_DATA") {
        setDisable(false);
        toast.dismiss();
        toast.success("Please wait for transaction confirm");
        setInputAmount(0);
        refetch();
        raisedRefetch();
        tokenRefetch();
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(error.code);
      }
    }
  };

  const normalBuy = async () => {
    try {
      const currencyType = currencyData.filter(
        (list) => list.value === currency
      );
      setDisable(true);
      if (chain === solChainEnum) {
        if (currencyType[0].priceCoin === "SOL") {
          const signature = await transfersol(inputAmount);
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: usdtAmount,
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 10000);
          }
        } else {
          const signature = await transferSPLToken(
            currencyType[0]?.decimal,
            currencyType[0]?.mintAddress,
            inputAmount
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: usdtAmount,
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 15000);
          }
        }
      } else {
        if (currencyType[0].type == coinTypeEnum) {
          const provider = await getSignerOrProvider();
          const contract = new Contract(
            eth_scotty_address,
            eth_scotty_abi,
            provider
          );

          const valueInWei = parseEther(inputAmount.toString());
          const trans = await contract.buyTokenWithETH(
            process.env.REACT_APP_adminAddress,
            {
              value: valueInWei,
            }
          );
          toast.dismiss();
          toast.info("Please Wait while we are validating transactions");
          await trans.wait();
          const transactionHash = trans.hash;
          const sendData = {
            user_address: address,
            chain: "ETH",
            currency: currencyType[0].key,
            amount: inputAmount,
            scotty_token: scottyToken,
            send_usdt_amount: usdtAmount,
            trans_id: transactionHash,
            to_address: process.env.REACT_APP_adminAddress,
            is_old: checkBox,
          };
          setTimeout(() => {
            setTransaction(sendData).then((result) => {
              if (result.data.status) {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
                setInputAmount(0);
                refetch();
                raisedRefetch();
                tokenRefetch();
                toast.dismiss();
                toast.success("Token buy successfully");
              } else {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
              }
            });
          }, 5000);
        } else {
          const provider = await getSignerOrProvider();
          const result = await approveToken(
            currencyType[0].tokenAddress,
            provider,
            eth_scotty_address,
            currencyType[0].decimal,
            currencyType[0].abi,
            inputAmount
          );
          if (result) {
            let trans;
            let contract = new Contract(
              eth_scotty_address,
              eth_scotty_abi,
              provider
            );
            trans = await contract.buyWithToken(
              (inputAmount * 10 ** currencyType[0].decimal).toString(),
              currency
            );

            toast.dismiss();
            toast.info("Please Wait while we are validating transactions", {
              autoClose: false,
            });
            await trans.wait();
            const transactionHash = trans.hash;
            const sendData = {
              user_address: address,
              chain: "ETH",
              currency: currencyType[0].key,
              amount: inputAmount,
              scotty_token: scottyToken,
              send_usdt_amount: usdtAmount,
              trans_id: transactionHash,
              to_address: process.env.REACT_APP_adminAddress,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  toast.dismiss();
                  toast.success("Token buy successfully");
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 5000);
          }
        }
      }
    } catch (error) {
      if (error.code == "BAD_DATA") {
        setDisable(false);
        toast.dismiss();
        toast.success("Please wait for transaction confirm");
        setInputAmount(0);
        refetch();
        raisedRefetch();
        tokenRefetch();
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(error.code);
      }
    }
  };

  const calculateExtraToken = async (value) => {
    if (value && value != ".") {
      if (currency) {
        const currencyType = currencyData.filter(
          (list) => list.value === currency
        );
        if (currencyType[0].type === coinTypeEnum) {
          const tokenOneDollarPrice = 1 / stage[0].scotty_token_price;
          const getData = await axios.get(
            `${getLivePriceURL}${currencyType[0].priceCoin}USDT`
          );
          const getScottyToken =
            tokenOneDollarPrice *
            parseFloat(value) *
            parseFloat(getData.data.price);
          return parseFloat(getScottyToken).toFixed(2);
        } else {
          const getScottyToken =
            parseFloat(value) / stage[0]?.scotty_token_price;
          return parseFloat(getScottyToken).toFixed(2);
        }
      } else {
        toast.dismiss();
        toast.error("Please select currency");
      }
    } else {
      return 0;
    }
  };

  const extraBuy = async () => {
    try {
      const currencyType = currencyData.filter(
        (list) => list.value === currency
      );
      setDisable(true);
      const token = calculateExtraToken(
        parseFloat(inputAmount) + parseFloat(extraAmount)
      );
      if (chain === solChainEnum) {
        if (currencyType[0].priceCoin === "SOL") {
          const signature = await transfersol(
            parseFloat(inputAmount) + parseFloat(extraAmount)
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(extraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(extraUsdtAmount),
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  setCheckBox(false);
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 10000);
          }
        } else {
          const signature = await transferSPLToken(
            currencyType[0]?.decimal,
            currencyType[0]?.mintAddress,
            parseFloat(inputAmount) + parseFloat(extraAmount)
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(extraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(extraUsdtAmount),
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  setCheckBox(false);
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 15000);
          }
        }
      } else {
        if (currencyType[0].type == coinTypeEnum) {
          const provider = await getSignerOrProvider();
          const contract = new Contract(
            eth_scotty_address,
            eth_scotty_abi,
            provider
          );

          const valueInWei = parseEther(
            (parseFloat(inputAmount) + parseFloat(extraAmount)).toString()
          );
          const trans = await contract.buyTokenWithETH(
            process.env.REACT_APP_adminAddress,
            {
              value: valueInWei,
            }
          );
          toast.dismiss();
          toast.info("Please Wait while we are validating transactions");
          await trans.wait();
          const transactionHash = trans.hash;
          const sendData = {
            user_address: address,
            chain: "ETH",
            currency: currencyType[0].key,
            amount: parseFloat(inputAmount) + parseFloat(extraAmount),
            scotty_token: token,
            send_usdt_amount:
              parseFloat(usdtAmount) + parseFloat(extraUsdtAmount),
            trans_id: transactionHash,
            to_address: process.env.REACT_APP_adminAddress,
            is_old: checkBox,
          };
          setTimeout(() => {
            setTransaction(sendData).then((result) => {
              if (result.data.status) {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
                setInputAmount(0);
                refetch();
                raisedRefetch();
                tokenRefetch();
                toast.dismiss();
                toast.success("Token buy successfully");
              } else {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
              }
            });
          }, 5000);
        } else {
          const provider = await getSignerOrProvider();
          const result = await approveToken(
            currencyType[0].tokenAddress,
            provider,
            eth_scotty_address,
            currencyType[0].decimal,
            currencyType[0].abi,
            parseFloat(inputAmount) + parseFloat(extraAmount)
          );
          if (result) {
            let trans;
            let contract = new Contract(
              eth_scotty_address,
              eth_scotty_abi,
              provider
            );
            trans = await contract.buyWithToken(
              (
                (parseFloat(inputAmount) + parseFloat(extraAmount)) *
                10 ** currencyType[0].decimal
              ).toString(),
              currency
            );

            toast.dismiss();
            toast.info("Please Wait while we are validating transactions", {
              autoClose: false,
            });
            await trans.wait();
            const transactionHash = trans.hash;
            const sendData = {
              user_address: address,
              chain: "ETH",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(extraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(extraUsdtAmount),
              trans_id: transactionHash,
              to_address: process.env.REACT_APP_adminAddress,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  toast.dismiss();
                  toast.success("Token buy successfully");
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 5000);
          }
        }
      }
    } catch (error) {
      if (error.code == "BAD_DATA") {
        setDisable(false);
        toast.dismiss();
        toast.success("Please wait for transaction confirm");
        setInputAmount(0);
        refetch();
        raisedRefetch();
        tokenRefetch();
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(error.code);
      }
    }
  };

  const maxExtraBuy = async () => {
    try {
      const currencyType = currencyData.filter(
        (list) => list.value === currency
      );
      setDisable(true);
      const token = calculateExtraToken(
        parseFloat(inputAmount) + parseFloat(maxExtraAmount)
      );
      if (chain === solChainEnum) {
        if (currencyType[0].priceCoin === "SOL") {
          const signature = await transfersol(
            parseFloat(inputAmount) + parseFloat(maxExtraAmount)
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(maxExtraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(maxExtraUsdtAmount),
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  setCheckBox(false);
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 10000);
          }
        } else {
          const signature = await transferSPLToken(
            currencyType[0]?.decimal,
            currencyType[0]?.mintAddress,
            parseFloat(inputAmount) + parseFloat(maxExtraAmount)
          );
          if (signature) {
            const sendData = {
              user_address: address,
              chain: "SOL",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(maxExtraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(maxExtraUsdtAmount),
              trans_id: signature,
              to_address: adminPublicKey,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  setCheckBox(false);
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 15000);
          }
        }
      } else {
        if (currencyType[0].type == coinTypeEnum) {
          const provider = await getSignerOrProvider();
          const contract = new Contract(
            eth_scotty_address,
            eth_scotty_abi,
            provider
          );

          const valueInWei = parseEther(
            (parseFloat(inputAmount) + parseFloat(maxExtraAmount)).toString()
          );
          const trans = await contract.buyTokenWithETH(
            process.env.REACT_APP_adminAddress,
            {
              value: valueInWei,
            }
          );
          toast.dismiss();
          toast.info("Please Wait while we are validating transactions");
          await trans.wait();
          const transactionHash = trans.hash;
          const sendData = {
            user_address: address,
            chain: "ETH",
            currency: currencyType[0].key,
            amount: parseFloat(inputAmount) + parseFloat(maxExtraAmount),
            scotty_token: token,
            send_usdt_amount:
              parseFloat(usdtAmount) + parseFloat(maxExtraUsdtAmount),
            trans_id: transactionHash,
            to_address: process.env.REACT_APP_adminAddress,
            is_old: checkBox,
          };
          setTimeout(() => {
            setTransaction(sendData).then((result) => {
              if (result.data.status) {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
                setInputAmount(0);
                refetch();
                raisedRefetch();
                tokenRefetch();
                toast.dismiss();
                toast.success("Token buy successfully");
              } else {
                toast.dismiss();
                toast.success(result.data.message);
                setDisable(false);
              }
            });
          }, 5000);
        } else {
          const provider = await getSignerOrProvider();
          const result = await approveToken(
            currencyType[0].tokenAddress,
            provider,
            eth_scotty_address,
            currencyType[0].decimal,
            currencyType[0].abi,
            parseFloat(inputAmount) + parseFloat(maxExtraAmount)
          );
          if (result) {
            let trans;
            let contract = new Contract(
              eth_scotty_address,
              eth_scotty_abi,
              provider
            );
            trans = await contract.buyWithToken(
              (
                (parseFloat(inputAmount) + parseFloat(maxExtraAmount)) *
                10 ** currencyType[0].decimal
              ).toString(),
              currency
            );

            toast.dismiss();
            toast.info("Please Wait while we are validating transactions", {
              autoClose: false,
            });
            await trans.wait();
            const transactionHash = trans.hash;
            const sendData = {
              user_address: address,
              chain: "ETH",
              currency: currencyType[0].key,
              amount: parseFloat(inputAmount) + parseFloat(maxExtraAmount),
              scotty_token: token,
              send_usdt_amount:
                parseFloat(usdtAmount) + parseFloat(maxExtraUsdtAmount),
              trans_id: transactionHash,
              to_address: process.env.REACT_APP_adminAddress,
              is_old: checkBox,
            };
            setTimeout(() => {
              setTransaction(sendData).then((result) => {
                if (result.data.status) {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                  setInputAmount(0);
                  refetch();
                  raisedRefetch();
                  tokenRefetch();
                  toast.dismiss();
                  toast.success("Token buy successfully");
                } else {
                  toast.dismiss();
                  toast.success(result.data.message);
                  setDisable(false);
                }
              });
            }, 5000);
          }
        }
      }
    } catch (error) {
      if (error.code == "BAD_DATA") {
        setDisable(false);
        toast.dismiss();
        toast.success("Please wait for transaction confirm");
        setInputAmount(0);
        refetch();
        raisedRefetch();
        tokenRefetch();
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(error.code);
      }
    }
  };

  async function transferSPLToken(tokenDecimals, mintAddress, inputamount) {
    return new Promise(async (resolve, reject) => {
      const connection = new Connection(
        "https://go.getblock.io/58f3aa8c996b4ca593a795d55712559c",
        "confirmed"
      );
      const publicKey = walletProvider?.publicKey;
      const senderPublicKey = publicKey;
      const recipientPublicKey = new PublicKey(adminPublicKey);
      const mintPublicKey = new PublicKey(mintAddress);
      const amount = inputamount * Math.pow(10, tokenDecimals);
      const senderTokenAccountAddress = await getAssociatedTokenAddress(
        mintPublicKey,
        senderPublicKey
      );
      const recipientTokenAccountAddress = await getAssociatedTokenAddress(
        mintPublicKey,
        recipientPublicKey
      );

      try {
        const transaction = new Transaction().add(
          createTransferInstruction(
            senderTokenAccountAddress,
            recipientTokenAccountAddress,
            senderPublicKey,
            amount,
            [],
            TOKEN_PROGRAM_ID
          )
        );
        const { blockhash, lastValidBlockHeight } =
          await connection.getLatestBlockhash();
        // Set transaction properties
        transaction.recentBlockhash = blockhash;
        transaction.feePayer = senderPublicKey;
        // Sign the transaction
        const signedTransaction = await walletProvider.signTransaction(
          transaction
        );
        // Send the transaction
        const signature = await connection.sendRawTransaction(
          signedTransaction.serialize()
        );

        // Confirm the transaction
        // await connection.confirmTransaction(
        //   { signature, lastValidBlockHeight, blockhash },
        //   "confirmed"
        // );
        resolve(signature);
      } catch (error) {
        reject(error.message);
      }
    });
  }

  const transfersol = (inputamount) => {
    return new Promise(async (resolve, reject) => {
      try {
        const connection = new Connection(
          "https://go.getblock.io/58f3aa8c996b4ca593a795d55712559c",
          "confirmed"
        );
        const publicKey = walletProvider?.publicKey;
        const transaction = new Transaction().add(
          SystemProgram.transfer({
            fromPubkey: publicKey,
            toPubkey: new PublicKey(adminPublicKey),
            lamports: parseFloat(inputamount) * LAMPORTS_PER_SOL,
          })
        );
        transaction.feePayer = publicKey;
        let { blockhash } = await connection.getLatestBlockhash();
        transaction.recentBlockhash = blockhash;
        const signedTransaction = await walletProvider.signTransaction(
          transaction
        );
        const signature = await connection.sendRawTransaction(
          signedTransaction.serialize()
        );
        resolve(signature);
      } catch (error) {
        reject(error);
      }
    });
  };

  return (
    <>
      <section className="hero position-relative ps-3 pe-3">
        <div className="row ">
          <div className="col-md-6 ">
            <img
              src="/assets/img/hero.jpg"
              alt="hero"
              className="img-fluid hro_img"
            />
          </div>
          <div className="col-md-4">
            {timeLeft.days != 0 &&
            timeLeft.hours != 0 &&
            timeLeft.minutes != 0 &&
            timeLeft.seconds != 0 ? (
              <div className="hero_box d-flex text-black h100">
                <div className="m-auto">
                  <h3 className=" mb-3 text-center">
                    <b>TRADE SCOTTY LIVE ON MEXC NOW</b>
                  </h3>
                  <p className=" mb-3 text-center"> $SCOTTY Presale Token claim starts in:</p>
                  <div id="clockdiv" className="mb-3">
                      <div className="t_box">
                        <span className="days font1" id="day">
                          {livetimeLeft.days}
                        </span>
                        <div className="smalltext">Days</div>
                      </div>
                      <div className="t_box">
                        <span className="hours font1" id="hour">
                          {livetimeLeft.hours}
                        </span>
                        <div className="smalltext">Hours</div>
                      </div>
                      <div className="t_box">
                        <span className="minutes font1" id="minute">
                          {livetimeLeft.minutes}
                        </span>
                        <div className="smalltext">Mins</div>
                      </div>
                      <div className="t_box">
                        <span className="seconds font1" id="second">
                          {livetimeLeft.seconds}
                        </span>
                        <div className="smalltext">Sec</div>
                      </div>
                    </div>
                  <p className="text-center">
                  $SCOTTY tokens claiming starts 27th of May 2025 at 12pm UTC. 
                  </p>
                  <p className="text-center">
                  <span className="wbba">
                  Add (6Xd8vYkTKdJJ2ZcktxVrU4qKiJ8xeTcT14xRrwWVgJBJ) </span> to your wallet to see your $SCOTTY balance after claiming.
                  </p>
				  <div className="text-center mb-3">
                  <a href="https://www.mexc.com/exchange/SCOTTYV2_USDT" className="mexc_btn" target="_blank">
                            <img
                              src="assets/img/mexc.png"
                              className="mexc_img "
                              alt="mexc logo"
                            />
                          </a>
						  </div>
                  {userToken &&
                    parseFloat(userToken[0]?.user_bonus_token).toFixed(2) >
                      0 && (
                      <h6 className="text-center">
                        {" "}
                        Your Bonus Scotty -{" "}
                        {authenticated
                          ? userToken &&
                            parseFloat(userToken[0]?.user_bonus_token).toFixed(
                              2
                            )
                          : 0}
                      </h6>
                    )}
                  <h6 className="text-center">
                    {" "}
                    Your Purchased SCOTTY -{" "}
                    {authenticated
                      ? userToken &&
                        parseFloat(userToken[0]?.user_buy_token).toFixed(2)
                      : 0}
                  </h6>
                  <div className=" pe-md-2 connect-btn">
                    <button
                      onClick={() => {
                        model.open();
                      }}
                      className="btn btn_2 mt-2 w-100"
                    >
                      {isConnected ? shortenAddress(address) : "Connect Wallet"}
                    </button>
                  </div>
                  {livetimeLeft.days==0&& livetimeLeft.hours==0 && livetimeLeft.minutes==0 && livetimeLeft.seconds==0 && showClaim && isConnected&& (
                    <div>
                      <button
                        className="btn btn_2 mt-3 w-100"
                        disabled={disable}
                        onClick={ClaimToken}
                      >
                        Claim Now{" "}
                        {parseFloat(claimtoken?.left_token).toFixed(2)}
                      </button>
                    </div>
                  )}
                </div>
                {disable && <Loader />}
              </div>
            ) : (
              <div className="hero_box text-center h100 position-relative">
                <div className="buy_box">
                  <h3 className="ttu font1">LAST STAGE BEFORE</h3>
                  <h3 className="ttu font1">TIER 1 CEX LISTING</h3>
                  <div className="buy_box_in">
                    <div id="clockdiv">
                      <div className="t_box">
                        <span className="days font1" id="day">
                          {timeLeft.days}
                        </span>
                        <div className="smalltext">Days</div>
                      </div>
                      <div className="t_box">
                        <span className="hours font1" id="hour">
                          {timeLeft.hours}
                        </span>
                        <div className="smalltext">Hours</div>
                      </div>
                      <div className="t_box">
                        <span className="minutes font1" id="minute">
                          {timeLeft.minutes}
                        </span>
                        <div className="smalltext">Mins</div>
                      </div>
                      <div className="t_box">
                        <span className="seconds font1" id="second">
                          {timeLeft.seconds}
                        </span>
                        <div className="smalltext">Sec</div>
                      </div>
                    </div>
                    <div
                      className="progress mt-3 position-relative"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div
                        className="progress-bar"
                        style={{ width: processBar }}
                      ></div>
                      <span className="ul_span">UNTIL LAUNCH </span>
                      {/* ({processBar}) */}
                    </div>
                    <div className="text-center pt-4">
                      <h6>
                        $USDT Raised: $
                        {tokenRaised &&
                          parseFloat(tokenRaised[0]?.usdt_raised).toFixed(2)}
                        /$
                        {stage &&
                          parseFloat(stage[0]?.usdt_amount_raised).toFixed(2)}
                      </h6>
                      {userToken &&
                        parseFloat(userToken[0]?.user_bonus_token).toFixed(2) >
                          0 && (
                          <h6>
                            {" "}
                            Your Bonus Scotty -{" "}
                            {authenticated
                              ? userToken &&
                                parseFloat(
                                  userToken[0]?.user_bonus_token
                                ).toFixed(2)
                              : 0}
                          </h6>
                        )}
                      <h6>
                        {" "}
                        Your Purchased SCOTTY -{" "}
                        {authenticated
                          ? userToken &&
                            parseFloat(userToken[0]?.user_buy_token).toFixed(2)
                          : 0}
                      </h6>
                      <div className="position-relative line text-center mt-4">
                        <div className="position-absolute">
                          <h6 className="m-0">
                            1 Scotty = ${stage && stage[0]?.scotty_token_price}
                          </h6>
                        </div>
                      </div>
                      {/* <h6 className="mb-2 mt-3">
                        Next Stage Price = $0.0004
                        </h6> */}
                    </div>
                    <div className="buy_tab chain_tab mt-4 text-center">
                      {chainTypeEnum.map((list) => {
                        return (
                          <a
                            className={`${chain == list.value ? "active" : ""}`}
                            key={list.key}
                            onClick={() => {
                              handleChain(list.value);
                            }}
                          >
                            <img src={list.image} alt="eth" />
                          </a>
                        );
                      })}
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-2 mb-2 mt-2 pe-md-2">
                        <div className="buy_tab text-center">
                          <Link to="/">
                            <img
                              src={chainImage}
                              className="card_img "
                              alt="solana-icon"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="col-md-10 mb-2 mt-2 pe-md-2">
                        <div className="b_box b_box_p d-flex select_box position-relative  align-items-center">
                          <select
                            className="select_r"
                            value={currency}
                            onChange={handleChange}
                            name="currency"
                          >
                            <option value="">Select Currency</option>
                            {currencyData?.map((list) => {
                              return (
                                <option value={list.value} key={list.key}>
                                  {list.key}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6 pe-md-2">
                        <label className="fw700 mb-2 d-flex small ls-1">
                          Payment Method
                          {/* <span className="ms-auto">max</span> */}
                        </label>
                        <div className="b_box b_box_p d-flex select_box position-relative  align-items-center">
                          <img
                            src={chainImage}
                            className="card_img "
                            alt="solana-icon"
                          />
                          <input
                            type="text"
                            className="buy_input"
                            value={inputAmount}
                            onChange={handleChange}
                            name="inputAmount"
                          />
                        </div>
                      </div>

                      <div className="col-md-6 ps-md-2">
                        <label className="fw700 mb-2 d-flex small ls-1">
                          Receive Scotty
                          {/* <span className="ms-auto">max</span> */}
                        </label>
                        <div className="b_box b_box_p d-flex select_box position-relative  align-items-center">
                          <img
                            src="/assets/img/logo-icon.png"
                            className="card_img "
                            alt="logo-icon"
                          />
                          <input
                            type="text"
                            className="buy_input"
                            disabled
                            value={scottyToken}
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-4 mt-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexCheckChecked"
                          checked={checkBox}
                          onChange={(e) => {
                            setCheckBox(!checkBox);
                          }}
                        />
                        <label
                          class="form-check-label"
                          htmlFor="flexCheckChecked"
                        >
                          SCOTTY on ETH Holders Get a 10% Bonus!
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 pe-md-2 connect-btn">
                        {/* <WalletMultiButton className="bg-orange-500 text-white rounded-lg hover:bg-orange-600">
                        {isConnected
                          ? shortenAddress(address)
                          : "Connect Phantom Wallet"}
                      </WalletMultiButton> */}
                        <button
                          onClick={() => {
                            model.open();
                          }}
                          className="btn btn_2 mt-3 w-100"
                        >
                          {isConnected
                            ? shortenAddress(address)
                            : "Connect Wallet"}
                        </button>
                        {/* {publicKey && <WalletDisconnectButton />} */}
                      </div>
                      {isConnected && (
                        <>
                          <div className="col-12 pe-md-2">
                            <button
                              className="btn btn_2 mt-3 w-100"
                              onClick={handleBuy}
                              disabled={disable}
                            >
                              Buy Now
                            </button>
                          </div>

                          {/* <div className="col-12 pe-md-2">
                          <Link
                            className="btn btn_2 mt-3 w-100"
                            to="/dashboard"
                          >
                            Dashboard
                          </Link>
                        </div> */}
                        </>
                      )}
                    </div>
                    <div className="an-logo">
                      <p className="m-0">
                        Security Audit By{" "}
                        <a
                          href="https://app.solidproof.io/projects/scotty-ai"
                          target="_blank"
                        >
                          {" "}
                          <img src="/assets/img/solidlogo.png" alt="" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <BuyPopup
                  setShowModal={setShowModal}
                  showModal={showModal}
                  extraAmount={extraAmount}
                  maxExtraAmount={maxExtraAmount}
                  bonus={bonus}
                  extrabonus={extrabonus}
                  maxExtrabonus={maxExtrabonus}
                  currencyName={currencyName}
                  normalBuy={normalBuy}
                  disable={disable}
                  extraBuy={extraBuy}
                  maxExtraBuy={maxExtraBuy}
                />
                {disable && <Loader />}
              </div>
            )}
          </div>
          <div className="col-md-2 pe-md-5 ">
            <div className="  text-center  pe-md-3 hero_right">
              <img
                src="/assets/img/hi1.png"
                alt="hero"
                className="img-fluid hi1 "
              />
              <img
                src="/assets/img/hi2.png"
                alt="hero"
                className="img-fluid hi1 "
              />
              <img
                src="/assets/img/hi3.png"
                alt="hero"
                className="img-fluid hi1 "
              />
            </div>
          </div>
        </div>
      </section>
      {/* <BuyModal
        setShowModal={setShowModal}
        showModal={showModal}
        extraAmount={extraAmount}
        maxExtraAmount={maxExtraAmount}
        bonus={bonus}
        extrabonus={extrabonus}
        maxExtrabonus={maxExtrabonus}
        currencyName={currencyName}
        normalBuy={normalBuy}
        disable={disable}
        extraBuy={extraBuy}
        maxExtraBuy={maxExtraBuy}
      /> */}
    </>
  );
}

export default BuySell;
